import {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import {Trans, useTranslation} from "react-i18next";
import {ApiConfig} from "../api/portal/ApiConfig.tsx";
import {PortalApi} from "../api/portal/generated";

const portalApi = new PortalApi(ApiConfig.config());

export const PortalHome = () => {

    const [organizationID, setOrganizationID] = useState<string>('')

    /**
     * i18next translation hook
     */
    const {t} = useTranslation('components');

    useEffect(() => {
        portalApi.portalControllerGetPortalProperties().then(
            (response) => {
                setOrganizationID(response.data.organizationID??"org id")
            }
        )
    }, []);

    return (
        <div className='m-4'>
            <Modal.Title>{t('portal-home.title')}</Modal.Title>
            <Trans values={{companyname: organizationID}}>
                {t('portal-home.intro1')}
            </Trans>
            <p className='mt-2'>{t('portal-home.intro2')}</p>
            <Trans>
                <h5>{t('portal-home.explanationTitle')}</h5>
                <ol>
                    <li className='mt-3'>{t('portal-home.option1')}</li>
                    <li>{t('portal-home.option2')}</li>
                </ol>
            </Trans>
            <Trans components={{anchor: <a href="https://ciphermail.com"></a>}}>
                {t('portal-home.intro3')}
            </Trans>
        </div>
    )
}
